
// region JS Imports

// region External Modules
import $ from "jquery"
import Promise from "plugins/bluebird"
import CleaveJs from "plugins/cleave-js/index"
import param from "jquery-param"
import URI from "urijs"

import I18n from "plugins/i18n-js"
// endregion External Modules

// Private Modules
import NumbersFormatter from "app/numbers/formatter/index"
import MortgageCalculate from "app/real_estate/mortgage/pmt/calculation/operation"
import DataRetriever from "app/data_retriever"

import {
  q_ajax_3,
} from "app/utils/q_ajax/q_ajax_3"
// Private Modules

// region Public Components
// endregion Public Components

// region Private Components
import {
  Factory as LoanTermSelector,
} from "./inputs/loan_term_selector"

import {
  InputSection,
} from "./inputs/input_section"

import PieChart from "./pie_chart"
import TableChart from "./table_chart"
import Schedule from "./schedule"
// endregion Private Components

// endregion JS Imports

import Modal from "app/modal/show-modal"

interface Selector {
  scope:              string
  main:               string
  form_input:         string
  listing_price:      string
  loan_amount:        string
  loan_amount_ratio:  string
  loan_amount_value:  string
  down_payment:       string
  interest_rate:      string
  commission:         string
  commission_rate:    string
  legal_fee:          string

  loan_period_container: string
  loan_period:           string
  payment_text:          string
  loan_term_years:       string
  loan_term_months:      string
  loan_term_increment:   string
  loan_term_decrement:   string

  schedule_container:   string
  schedule_cell:        string
  schedule_cell_toggle: string

  calculator_data:    string
  pie_chart:          string
  mortgage_breakdown: string

  pie_chart_container:  string
}
interface InputSelector {
  scope?:               string | JQuery
  main?:                string | JQuery
  form_input?:          string
  listing_price?:       string
  loan_amount?:         string
  loan_amount_ratio?:   string
  loan_amount_value?:   string
  down_payment?:        string
  interest_rate?:       string
  commission?:          string
  commission_rate?:     string
  legal_fee?:           string

  loan_period_container?:  string
  loan_period?:            string
  payment_text?:           string
  loan_term_years?:        string
  loan_term_months?:       string
  loan_term_increment?:    string
  loan_term_decrement?:    string

  schedule_container?:   string
  schedule_cell?:        string
  schedule_cell_toggle?: string

  calculator_data:    string
  pie_chart:          string
  mortgage_breakdown: string

  pie_chart_container?:  string
}
const DEFAULT_SELECTOR = {
  scope:              "body",
  main:               ".cell-real-estate-mortgages-calculator",
  form_input:         ".cell-real-estate-mortgages-calculator_form-input",
  listing_price:      ".cell-real-estate-mortgages-calculator--listing-price",
  loan_amount:        ".cell-real-estate-mortgages-calculator--loan-amount",
  loan_amount_value:  ".cell-real-estate-mortgages-calculator_form-loan-amount-input",
  loan_amount_ratio:  ".cell-real-estate-mortgages-calculator_form-loan-amount-ratio-input",
  down_payment:       ".cell-real-estate-mortgages-calculator--down-payment",
  interest_rate:      ".cell-real-estate-mortgages-calculator--interest-rate",
  commission:         ".cell-real-estate-mortgages-calculator--commission",
  commission_rate:    ".cell-real-estate-mortgages-calculator--commission-rate",
  legal_fee:          ".cell-real-estate-mortgages-calculator--legal-fee",

  loan_period_container: ".cell-real-estate-mortgages-calculator_loan-term--container",
  loan_period:           ".cell-real-estate-mortgages-calculator_loan-term",
  payment_text:          ".cell-real-estate-mortgages-calculator_data--monthly-payment-text",
  loan_term_years:       ".cell-real-estate-mortgages-calculator--loan-term-years",
  loan_term_months:      ".cell-real-estate-mortgages-calculator--loan-term-months",
  loan_term_increment:   ".cell-real-estate-mortgages-calculator_form_input--increment",
  loan_term_decrement:   ".cell-real-estate-mortgages-calculator_form_input--decrement",

  schedule_container:   ".cell-real-estate-mortgages-calculator_schedule--table-body",
  schedule_cell:        ".cell-real-estate-mortgages-calculator_schedule",
  schedule_cell_toggle: ".cell-real-estate-mortgages-calculator_schedule--toggle",

  calculator_data:    ".cell-real-estate-mortgages-calculator_data",
  pie_chart:          ".cell-real-estate-mortgages-calculator_pie-chart",
  mortgage_breakdown: ".cell-real-estate-mortgages-calculator_data--mortgage-breakdown",

  pie_chart_container:  "#cell-real-estate-mortgages-calculator_pie-chart",
}

const LOAN_TERM_YEAR_MAX = 30
const LOAN_TERM_YEAR_MIN = 5
const LOAN_TERM_MONTH_MAX = 11
const LOAN_TERM_MONTH_MIN = 0

const main_navbar_height = parseFloat($("#main-navbar").css("height"))
const banner_height =  parseFloat($("#layout-section--mobile-searcher-app-smart-banner").css("height"))

type SectionType = InputSection

class Calculator {
  protected selector: Selector

  protected $scope: JQuery
  protected $el: JQuery

  // for storing smart banner is here or not
  protected smart_banner_is_shown: boolean

  protected $loan_period_container: JQuery
  protected $loan_period: JQuery

  protected $payment_text: JQuery
  protected $loan_term_years: JQuery
  protected $loan_term_years_input: JQuery
  protected $loan_term_years_increment: JQuery
  protected $loan_term_years_decrement: JQuery
  protected $loan_term_months: JQuery
  protected $loan_term_months_input: JQuery
  protected $loan_term_months_increment: JQuery
  protected $loan_term_months_decrement: JQuery

  protected $schedule_container: JQuery
  protected $schedule_cell: JQuery
  protected $schedule_cell_toggle: JQuery

  protected $calculator_data: JQuery
  protected $pie_chart: JQuery
  protected $mortgage_breakdown: JQuery

  protected $pie_chart_container: JQuery

  protected $loan_amount: JQuery
  protected $loan_amount_ratio: JQuery
  protected $loan_amount_value: JQuery
  protected $down_payment: JQuery

  protected $interest_rate: JQuery

  protected $commission: JQuery
  protected $commission_rate: JQuery
  protected $legal_fee: JQuery

  protected sections: {
    listing_price:    SectionType | JQuery
    loan_amount:      SectionType
    down_payment:     SectionType
    interest_rate:    SectionType
    commission:       SectionType
    commission_rate:  SectionType
    legal_fee:        SectionType
    loan_term_years:  SectionType
    loan_term_months: SectionType
  }

  protected calculation_result_init_height: number
  protected clientY: number

  constructor(selector?: InputSelector){
    this.selector = Object.assign({}, DEFAULT_SELECTOR, selector)
    this.$scope = $(this.selector.scope)
    this.$el = this.$scope.find(this.selector.main)

    this.smart_banner_is_shown = false

    // input fields for listing page only
    this.$payment_text = this.$el.find(this.selector.payment_text)

    this.$down_payment = this.$el.find(this.selector.down_payment)

    this.$loan_period = this.$el.find(this.selector.loan_period)
    this.$loan_period_container = this.$el.find(this.selector.loan_period_container)

    this.$commission_rate = this.$el.find(this.selector.commission_rate)
    // end of for listing page only

    // initialize the value of these variables to 0 for opening sort menu at first time
    this.calculation_result_init_height = 0
    this.clientY = 0

    this.$loan_amount = this.$el.find(this.selector.loan_amount)
    this.$loan_amount_ratio = this.$el.find(this.selector.loan_amount_ratio)
    this.$loan_amount_value = this.$el.find(this.selector.loan_amount_value)

    this.$loan_term_years = this.$el.find(this.selector.loan_term_years)
    this.$loan_term_years_input = this.$loan_term_years.find(this.selector.form_input)
    this.$loan_term_years_increment = this.$loan_term_years.find(this.selector.loan_term_increment)
    this.$loan_term_years_decrement = this.$loan_term_years.find(this.selector.loan_term_decrement)
    this.$loan_term_months = this.$el.find(this.selector.loan_term_months)
    this.$loan_term_months_input = this.$loan_term_months.find(this.selector.form_input)
    this.$loan_term_months_increment = this.$loan_term_months.find(this.selector.loan_term_increment)
    this.$loan_term_months_decrement = this.$loan_term_months.find(this.selector.loan_term_decrement)

    this.$interest_rate = this.$el.find(this.selector.interest_rate)

    this.$commission = this.$el.find(this.selector.commission)
    this.$legal_fee = this.$el.find(this.selector.legal_fee)

    this.$schedule_cell = this.$scope.find(this.selector.schedule_cell)
    this.$schedule_container = this.$schedule_cell.find(this.selector.schedule_container)
    this.$schedule_cell_toggle = this.$schedule_cell.find(this.selector.schedule_cell_toggle)

    this.$calculator_data = this.$el.find(this.selector.calculator_data)
    this.$pie_chart = this.$el.find(this.selector.pie_chart)
    this.$mortgage_breakdown = this.$el.find(this.selector.mortgage_breakdown)

    this.$pie_chart_container = this.$el.find(this.selector.pie_chart_container)

    let listing_price_value
    if (this.$el.hasClass("cell-real-estate-mortgages-calculator-listing-page--mobile")){
      listing_price_value = this.$el.find(this.selector.listing_price)
    }else{
      listing_price_value = this.init_section(this.selector.listing_price)
    }

    this.sections = {
      listing_price:    listing_price_value,
      loan_amount:      this.init_section(this.selector.loan_amount),
      down_payment:     this.init_section(this.selector.down_payment),
      interest_rate:    this.init_section(this.selector.interest_rate),
      commission:       this.init_section(this.selector.commission),
      commission_rate:  this.init_section(this.selector.commission_rate),
      legal_fee:        this.init_section(this.selector.legal_fee),
      loan_term_years:  this.init_section(this.selector.loan_term_years),
      loan_term_months: this.init_section(this.selector.loan_term_months),
    }

    if (this.$el.length === 0) { return }

    if(this.$down_payment.val() != null){
      this.refreshDownPaymentValue()
    }

    if (document.querySelector(".layout-section--mobile-searcher-app-smart-banner--shown") && document.querySelector(".cell--mobile-apps--searcher-app--smart-banner--default-style") != null) {
      this.smart_banner_is_shown = true
    }

    this.bind_action()
  }

  public created(): Promise<void> {
    if (this.$el.length === 0) {
      return Promise.resolve()
    }

    CleaveJs.init()

    if (this.$loan_period_container.length > 0) {
      LoanTermSelector.create()
    }

    return this.refreshPmtAndSchedule()
  }

  protected bind_action(){
    this.$schedule_cell_toggle.on("click", () => {
      this.onScheduleToggleClick()
    })

    if (this.$el.hasClass("cell-real-estate-mortgages-calculator--mobile")) {
      let total_height = main_navbar_height + 10

      if (this.smart_banner_is_shown) {
        total_height += banner_height
      }
      // change height of calculator data when dismissing download banner
      $(".cell--mobile-apps--searcher-app--smart-banner--default-style__close-banner-button").on("click", () => {
        total_height -= banner_height

        if (parseFloat(this.$calculator_data.css("height")) !== 180) {
          this.$calculator_data.css({"height": "calc(100% - " + total_height + "px)", "transition": "height 0.2s"})
        }

        // reset smart banner show flag to false
        this.smart_banner_is_shown = false
      })

      const calculation_result = document.querySelector(".cell-real-estate-mortgages-calculator_data") as Element

      calculation_result.addEventListener("touchstart", (e) => {
        const touchEvent: TouchEvent = e as TouchEvent

        this.clientY = touchEvent.touches[0].clientY
        this.calculation_result_init_height = parseFloat(this.$calculator_data.css("height"))

        this.$scope.css({"overflow": "hidden", "position": "fixed"})
        calculation_result.setAttribute("data-slideout-ignore", "true")
      })

      let calculator_data_scrollTop = 0

      calculation_result.addEventListener("touchmove",(e) => {
        e.preventDefault()

        const touchEvent: TouchEvent = e as TouchEvent

        let new_height = this.calculation_result_init_height + (this.clientY - touchEvent.touches[0].clientY)

        if (this.calculation_result_init_height !== 180) {
          new_height = Math.min(new_height, this.calculation_result_init_height)
          this.$calculator_data.scrollTop(calculator_data_scrollTop + (this.clientY - touchEvent.touches[0].clientY))
        }

        if (calculation_result.scrollTop === 0) {
          this.$calculator_data.css({"height": Math.max(180, new_height), "transition": ""})
        }


        if (new_height > 180) {
          this.$pie_chart.addClass("full")
          this.$mortgage_breakdown.addClass("full")
        }
        else {
          this.$pie_chart.removeClass("full")
          this.$mortgage_breakdown.removeClass("full")
        }
      })

      calculation_result.addEventListener("touchend", (e) => {
        const touchEvent: TouchEvent = e as TouchEvent

        if (Math.abs(this.clientY - touchEvent.changedTouches[0].clientY) > 0) {

          if (this.clientY < touchEvent.changedTouches[0].clientY) {
            this.$calculator_data.scrollTop(0)

            this.$calculator_data.css({"height": "180px", "transition": "height 0.5s", "overflow-y": "hidden"})
            setTimeout(() => {
              this.$pie_chart.removeClass("full")
              this.$mortgage_breakdown.removeClass("full")
            },300)

            $(".cell-real-estate-mortgages-calculator_schedule--table-actions").css("display","none")

            this.$scope.css({"overflow": "", "position": ""})
            calculation_result.removeAttribute("data-slideout-ignore")
          }
          else {
            this.$calculator_data.css({"height": "calc(100% - " + total_height + "px)", "transition": "height 0.5s", "overflow-y": "auto"})
            this.$pie_chart.addClass("full")
            this.$mortgage_breakdown.addClass("full")

            $(".cell-real-estate-mortgages-calculator_schedule--table-actions").css("display","block")
          }
        }
        else {
          if (calculation_result.getBoundingClientRect().height === 180) {
            this.$scope.css({"overflow": "", "position": ""})
            calculation_result.removeAttribute("data-slideout-ignore")
          }
        }

        calculator_data_scrollTop = this.$calculator_data.scrollTop() || 0
      })
    }

    this.$loan_period.on("change", () => {
      this.refreshPmtAndSchedule().done()
    })

    this.$down_payment.on("change", () => {
      this.refreshDownPaymentValue()
      this.refreshPmtAndSchedule().done()
    })

    this.$loan_amount_value.on("change", () => {
      this.refreshLoanAmountRatio()
      this.refreshPmtAndSchedule().done()
    })

    this.$loan_amount_ratio.on("change", () => {
      this.refreshLoanAmountValue()
      this.refreshPmtAndSchedule().done()
    })

    this.$interest_rate.on("input", () => {
      const parsed_input = (this.$interest_rate.find("input").val() as string).split(/[^0-9.]/).join("")

      this.$interest_rate.find("input").val(parsed_input.slice(0,5))
    })

    // region loan term years and months

    this.$loan_term_years_decrement.on("click", () => {
      const years = this.sections.loan_term_years.val() || 0
      const months = this.sections.loan_term_months.val() || 0

      if (months === LOAN_TERM_MONTH_MIN && years === LOAN_TERM_YEAR_MIN){
        return
      }
      if (years - 1 < LOAN_TERM_YEAR_MIN) {
        this.$loan_term_months_input.val(
          this.getLoanTermMonthsWithUnit(LOAN_TERM_MONTH_MIN)
        )
      }
      else {
        this.$loan_term_years_input.val(
          this.getLoanTermYearsWithUnit(years - 1)
        )
      }
      this.refreshPmtAndSchedule().done()
    })

    this.$loan_term_years_increment.on("click", () => {
      const years = this.sections.loan_term_years.val() || 0
      const months = this.sections.loan_term_months.val() || LOAN_TERM_MONTH_MIN

      if (months === LOAN_TERM_MONTH_MIN && years === LOAN_TERM_YEAR_MAX){
        return
      }
      if (years + 1 === LOAN_TERM_YEAR_MAX) {
        this.$loan_term_months_input.val(
          this.getLoanTermMonthsWithUnit(LOAN_TERM_MONTH_MIN)
        )
      }
      this.$loan_term_years_input.val(
        this.getLoanTermYearsWithUnit(years + 1)
      )
      this.refreshPmtAndSchedule().done()
    })

    this.$loan_term_months_decrement.on("click", () => {
      const years = this.sections.loan_term_years.val() || 0
      const months = this.sections.loan_term_months.val() || LOAN_TERM_MONTH_MIN

      if (months === 0 && years === LOAN_TERM_YEAR_MIN){
        return
      }
      if (months === LOAN_TERM_MONTH_MIN) {
        this.$loan_term_years_input.val(
          this.getLoanTermYearsWithUnit(years - 1)
        )
        this.$loan_term_months_input.val(
          this.getLoanTermMonthsWithUnit(LOAN_TERM_MONTH_MAX)
        )
      }// for 0 months case
      else {
        this.$loan_term_months_input.val(
          this.getLoanTermMonthsWithUnit(months - 1)
        )
      }
      this.refreshPmtAndSchedule().done()
    })

    this.$loan_term_months_increment.on("click", () => {
      const years = this.sections.loan_term_years.val() || 0
      const months = this.sections.loan_term_months.val() || LOAN_TERM_MONTH_MIN

      if (months === LOAN_TERM_MONTH_MIN && years === LOAN_TERM_YEAR_MAX){
        return
      }
      if (months === LOAN_TERM_MONTH_MAX) {
        this.$loan_term_years_input.val(
          this.getLoanTermYearsWithUnit(years + 1)
        )
        this.$loan_term_months_input.val(
          this.getLoanTermMonthsWithUnit(LOAN_TERM_MONTH_MIN)
        )
      } // for LOAN_TERM_MONTH_MAX months case
      else {
        this.$loan_term_months_input.val(
          this.getLoanTermMonthsWithUnit(months + 1)
        )
      }
      this.refreshPmtAndSchedule().done()
    })

    this.$loan_term_years_input.on("change", () => {
      const years = this.sections.loan_term_years.val() || 0

      if (years >= LOAN_TERM_YEAR_MAX) {
        this.$loan_term_years_input.val(LOAN_TERM_YEAR_MAX)
        this.$loan_term_months_input.val(this.getLoanTermMonthsWithUnit(LOAN_TERM_MONTH_MIN))
      }
      else if (years <= LOAN_TERM_YEAR_MIN) {
        this.$loan_term_years_input.val(LOAN_TERM_YEAR_MIN)
        this.$loan_term_months_input.val(this.getLoanTermMonthsWithUnit(LOAN_TERM_MONTH_MIN))
      }
      else {
        this.$loan_term_years_input.val(
          this.sections.loan_term_years.val() || 0
        )
      }
      this.$loan_term_years_input.blur()
    })

    this.$loan_term_months_input.on("change", () => {
      const years = this.sections.loan_term_years.val() || 0
      const months = this.sections.loan_term_months.val() || LOAN_TERM_MONTH_MIN

      if (years === LOAN_TERM_YEAR_MAX){// value of months will always be 0 if value of year is 30
        this.$loan_term_months_input.val(LOAN_TERM_MONTH_MIN)
      }
      else if (months > LOAN_TERM_MONTH_MAX) {// for case months input > 11
        const new_years = Math.min(LOAN_TERM_YEAR_MAX, years + Math.floor(months / 12))
        const new_months = new_years === LOAN_TERM_YEAR_MAX ? LOAN_TERM_MONTH_MIN : months % 12
        this.$loan_term_years_input.val(
          this.getLoanTermYearsWithUnit(new_years)
        )
        this.$loan_term_months_input.val(
          this.getLoanTermMonthsWithUnit(new_months)
        )
      }
      else {
        this.$loan_term_months_input.val(
          months
        )
      }
      this.$loan_term_months_input.blur()
    })

    this.$loan_term_years_input.on("blur", () => {
      this.$loan_term_years_input.val(
        this.getLoanTermYearsWithUnit(this.sections.loan_term_years.val() || 0)
      )
    })

    this.$loan_term_years_input.on("focus", () => {
      this.$loan_term_years_input.val(
        this.sections.loan_term_years.val() || 0
      )
    })

    this.$loan_term_months_input.on("blur", () => {
      this.$loan_term_months_input.val(
        this.getLoanTermMonthsWithUnit(this.sections.loan_term_months.val() || LOAN_TERM_MONTH_MIN)
      )
    })

    this.$loan_term_months_input.on("focus", () => {
      this.$loan_term_months_input.val(
        this.sections.loan_term_months.val() || LOAN_TERM_MONTH_MIN
      )
    })

    // endregion loan term years and months
  }
  protected init_section(css_selector: string): SectionType {

    const section = new InputSection({
      main: css_selector,
    })

    section.on("input_change", () => {
      this.refreshPmtAndSchedule().done()
    })
    return section
  }

  protected getLoanTermYearsWithUnit(years: number) {
    return years + " " + I18n.t("concepts.real_estate.mortgages.calculator.data.labels.year")
  }

  protected getLoanTermMonthsWithUnit(months: number) {
    return months + " " + I18n.t("concepts.real_estate.mortgages.calculator.data.labels.month")
  }

  protected getDownPaymentValue() {
    return Math.round((this.sections.listing_price.val() || 0) * ((this.sections.down_payment.val() || 0) / 100.0))
  }
  protected refreshDownPaymentValue(){
    this.$down_payment.find(".cell-real-estate-mortgages-calculator_form-inactive-input").val(
      NumbersFormatter.numberWithCommas(this.getDownPaymentValue()) || "")
  }
  protected getLoanAmountValue() {
    return Math.round((this.sections.listing_price.val() || 0) * ((this.$loan_amount_ratio.val() || 0) / 100.0))
  }
  protected getLoanAmountRatio() {
    return ((NumbersFormatter.numberWithoutCommas(this.$loan_amount_value.val()) || 0) / this.sections.listing_price.val()) * 100
  }
  protected refreshLoanAmountValue() {
    this.$loan_amount_value.val(
      NumbersFormatter.numberWithCommas(this.getLoanAmountValue()) || 0
    )
  }
  protected refreshLoanAmountRatio() {
    this.$loan_amount_ratio.val(
      Math.min(Math.round(this.getLoanAmountRatio()), 100) || 0
    )
  }
  protected getFormattedCommissionValue() {
    this.$commission.find(this.selector.form_input).val(
      NumbersFormatter.numberWithCommas(this.sections.commission.val() || 0) || 0
    )
  }
  protected getFormattedLegalFeeValue() {
    this.$legal_fee.find(this.selector.form_input).val(
      NumbersFormatter.numberWithCommas(this.sections.legal_fee.val() || 0) || 0
    )
  }
  protected getLoanTermInputWithUnit() {
    this.$loan_term_years_input.val(
      this.getLoanTermYearsWithUnit(this.sections.loan_term_years.val() || 0)
    )
    this.$loan_term_months_input.val(
      this.getLoanTermMonthsWithUnit(this.sections.loan_term_months.val() || LOAN_TERM_MONTH_MIN)
    )
  }
  protected refreshPmtOnly() {
    this.refreshLoanAmountValue()
    const loan_period = (this.sections.loan_term_years.val() || 0) + (this.sections.loan_term_months.val() || 0) / 12
    const pmt_value = (new MortgageCalculate({
      annual_interest_rate: this.sections.interest_rate.val() || 0,
      loan_period_years:    Math.min(LOAN_TERM_YEAR_MAX, loan_period) || this.$loan_period.val(),
      listing_price:        this.sections.listing_price.val() || 0,
      loan_amount_ratio:    this.sections.loan_amount.val() || (100 - (this.sections.down_payment.val() || 0)),
    })).call().result
    this.$payment_text.text(NumbersFormatter.numberWithCommasAndCurrency(pmt_value) || "")
    return pmt_value
  }
  protected refreshPmtAndSchedule(): Promise<void> {
    return new Promise((resolve) => {

      this.getLoanTermInputWithUnit()
      this.getFormattedCommissionValue()
      this.getFormattedLegalFeeValue()

      const pmt_value = this.refreshPmtOnly()
      const commission_value = this.sections.listing_price.val() * (this.sections.commission_rate.val() || 0) / 100

      const current_city_id = DataRetriever.get("current-city-id")
      Promise.resolve(
        import(
          "plugins/js-routes"
        )
      )
      .then((Routes) => {
        window.Routes = Routes
        const url = Routes.schedule_calculator_city_real_estate_mortgages_path(I18n.locale, current_city_id)
        const url_object = URI(url)
        url_object.query(param({
          loan_term_years:        this.sections.loan_term_years.val() || this.$loan_period.val(),
          loan_term_months:       this.sections.loan_term_months.val() || 0,
          listing_price:          this.sections.listing_price.val(),
          loan_amount_ratio:      this.sections.loan_amount.val() || (100 - (this.sections.down_payment.val() || 0)),
          annual_interest_rate:   this.sections.interest_rate.val(),
          commission:             this.sections.commission.val() || commission_value,
          legal_fee:              this.sections.legal_fee.val() || 0,
          pmt_value:              pmt_value,
        }))

        q_ajax_3({
          url:      url_object.toString(),
          method:   "GET",
          dataType: "json",
        })
        .then(({data}) => {
          const {ad_valorem_stamp_duty, down_payment, loan_amount, total_interest, commission, total_cost, schedule_data, legal_fee, loan_term_years, loan_term_months} = data
          if (this.$pie_chart_container.length > 0 ){
            PieChart.create({
              ad_valorem_stamp_duty,
              down_payment,
              loan_amount,
              total_interest,
              commission,
              total_cost,
              legal_fee,
              pmt_value,
              loan_term_years,
              loan_term_months,
            })
            if (this.$el.hasClass("cell-real-estate-mortgages-calculator--mobile")) {
              TableChart.create({
                ad_valorem_stamp_duty,
                down_payment,
                loan_amount,
                total_interest,
                commission,
                total_cost,
                legal_fee,
              })
            }
          }else{
            TableChart.create({
              ad_valorem_stamp_duty,
              down_payment,
              loan_amount,
              total_interest,
              commission,
              total_cost,
              legal_fee,
            })
          }

          if (this.$schedule_container.length > 0 ){
            this.$schedule_container.html(Schedule.render(schedule_data))
          }

          resolve()
        })
      })
      .done()
    })
  }
  protected onScheduleToggleClick(){
    Modal.showModalWithContent(this.$schedule_container, {
      customContent:      true,
      class:              "container",
    })
    // This part will be used later
    // $(".cell-real-estate-mortgages-calculator_schedule--table-title-download").on("click", () => {
    //   // TODO: generate and download a pdf file with schedule data when click it

    //   // put codes below back to shedule.html._tpl after finishing this function
    //   // <a class = "cell-real-estate-mortgages-calculator_schedule--table-title-download">
    //   // 	<%= I18n.t('concepts.real_estate.mortgages.calculator.schedule.labels.installment') %>.pdf
    //   // 	<i class="fa fa-download"></i>
    //   // </a>

    // })
  }
}



const init = (): Calculator => {
  const obj = new Calculator()
  obj.created().done()
  return obj
}

function init_async(): Promise<void> {
  const obj = new Calculator()
  return obj.created()
}


export {
  init as default,
  init,
  init_async,
}
